import { ILocationEventDetailRepository } from '../repositories/ILocationEventDetailRepository';

export class ToggleLocationLikeUseCase {
  constructor(private readonly repository: ILocationEventDetailRepository) {}

  async execute(locationId: string): Promise<boolean> {
    return this.repository.toggleLike(locationId);
  }
}
